import styled from "styled-components/native";
import ImgProgressBar from "./ImgProgressBar";

const StyledContainer = styled.View`
	gap: 1.5rem;
`;

const StyledLoading = styled.View<any>`
	display: flex;
	height: 13.5rem;
	flex-direction: column;
	align-items: flex-start;
	gap: 1rem;
	align-self: stretch;
	border-radius: 1rem;
`;

const SettingsLoader = (props: any) => {
	return (
		<>
			{/* @ts-ignore */}
			<StyledContainer>
				<StyledLoading>
					<ImgProgressBar isBorder />
				</StyledLoading>
				<StyledLoading>
					<ImgProgressBar isBorder />
				</StyledLoading>
				<StyledLoading>
					<ImgProgressBar isBorder />
				</StyledLoading>
			</StyledContainer>
		</>
	);
};

export default SettingsLoader;
